import { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function CheckoutReturn() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("polling");
  const [detail, setDetail] = useState(null);
  const attempts = useRef(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (!sessionId) { setState("failed"); return; }
    let cancelled = false;
    const poll = async () => {
      if (cancelled) return;
      try {
        const { data } = await api.get(`/checkout/status/${sessionId}`);
        setDetail(data);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (data.status === "expired") { setState("expired"); return; }
        attempts.current++;
        if (attempts.current >= 8) { setState("timeout"); return; }
        setTimeout(poll, 2000);
      } catch { setState("failed"); }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  return (
    <div data-testid="checkout-return-page" className="container-editorial py-24 max-w-xl text-center">
      {state === "polling" && (<>
        <Loader2 className="h-10 w-10 mx-auto animate-spin text-accent" strokeWidth={1.5}/>
        <h1 className="font-display text-3xl mt-6">Confirming payment…</h1>
        <p className="text-muted-foreground mt-2">This can take a few seconds.</p>
      </>)}
      {state === "paid" && (<>
        <CheckCircle2 className="h-14 w-14 mx-auto text-primary" strokeWidth={1.5}/>
        <h1 className="font-display text-4xl mt-6">Slip secured.</h1>
        <p className="text-muted-foreground mt-3">Your booking is paid and confirmed. The owner has been notified.</p>
        <Button data-testid="return-dashboard-btn" onClick={() => navigate("/dashboard")} className="mt-8 rounded-full bg-primary hover:bg-primary/90">Go to my bookings</Button>
      </>)}
      {(state === "failed" || state === "timeout" || state === "expired") && (<>
        <XCircle className="h-14 w-14 mx-auto text-destructive" strokeWidth={1.5}/>
        <h1 className="font-display text-3xl mt-6">We couldn't confirm payment.</h1>
        <p className="text-muted-foreground mt-3">If you were charged, check your dashboard in a few minutes.</p>
        <Button variant="outline" onClick={() => navigate("/dashboard")} className="mt-8">Back to dashboard</Button>
      </>)}
    </div>
  );
}
